// AuthContext.js

import React, { createContext, useContext, useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userToken, setUserToken] = useState('');
  const [userId, setUserId] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [forceUpdate, setForceUpdate] = useState(false);

  useEffect(() => {
    // Försök hämta autentiseringsstatus från localStorage vid sidladdning
    const storedToken = localStorage.getItem('token');
    if (storedToken !== null) {
      try {
        const decoded = jwtDecode(storedToken);
        
        // Kontrollera om token är expired
        const currentTime = Date.now() / 1000; // Konvertera till sekunder
        if (decoded.exp && decoded.exp < currentTime) {
          localStorage.removeItem('token');
          setIsLoggedIn(false);
          setUserId(null);
          setUserRole(null);
          setCurrentUser(null);
          return;
        }
        
        // Token är giltig
        setIsLoggedIn(true);
        setUserId(decoded.userId);
        setUserRole(decoded.userRole);
        setCurrentUser(decoded.userId);
      } catch (error) {
        // Token är ogiltig (kan inte dekodas)
        console.error('Ogiltig token i localStorage:', error);
        localStorage.removeItem('token');
        setIsLoggedIn(false);
        setUserId(null);
        setUserRole(null);
        setCurrentUser(null);
      }
    } else {
      setIsLoggedIn(false);
      setUserId(null); // Återställ userId vid utloggning
      setUserRole(null); // Återställ userRole vid utloggning
    }
  }, [localStorage.getItem('token')]); 

  const login = (token) => {
    setIsLoggedIn(true);
    localStorage.setItem('token', token);
    setUserToken(token);
    const decoded = jwtDecode(token);
    setUserId(decoded.userId);
    setUserRole(decoded.userRole);
    setCurrentUser(decoded.userId);
    setForceUpdate(prev => !prev);
  };
  
  const logout = () => {
    localStorage.removeItem('token');
    window.location.href = '/info';
  };

  const contextValue = {
    currentUser,
    userId,
    userRole,  
    isLoggedIn, 
    login, 
    logout, 
    setIsLoggedIn, 
    forceUpdate,
    setForceUpdate// ... andra värden och funktioner som behövs i context
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

